// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MmAg","delete":"styles_delete__3lPki","update":"styles_update__FhybQ","add":"styles_add__2Tzag"};